import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.854 1.146a.5.5 0 0 0-.708.708c1.136 1.135 1.729 2.87 1.729 4.646 0 1.776-.593 3.511-1.729 4.646a.5.5 0 0 0 .708.708c1.364-1.365 2.021-3.38 2.021-5.354 0-1.974-.657-3.989-2.021-5.354zm-2 2a.5.5 0 0 0-.708.708c.635.635.979 1.62.979 2.646 0 1.026-.344 2.011-.979 2.646a.5.5 0 0 0 .708.708c.865-.865 1.271-2.13 1.271-3.354 0-1.224-.406-2.489-1.271-3.354zM4 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM1 14c0-1.113.903-2 2.009-2H13a2 2 0 0 1 2 2c0 1.691-.833 2.966-2.135 3.797C11.583 18.614 9.855 19 8 19c-1.855 0-3.583-.386-4.865-1.203C1.833 16.967 1 15.69 1 14zm2.009-1C2.448 13 2 13.447 2 14c0 1.309.622 2.284 1.673 2.953C4.743 17.636 6.265 18 8 18c1.735 0 3.257-.364 4.327-1.047C13.377 16.283 14 15.31 14 14a1 1 0 0 0-1-1H3.009z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }